export const ANIMATION_PRIORITIES = {
  "4": 100, "6": 100, W: 100, WD: 100, NB: 100,
  HAT_TRICK: 100, HAT_TRICK_BALL: 100, OVER_SUMMARY: 90,
  NEW_BATTER: 80, NEW_BOWLER: 80, MILESTONE: 75, STREAK: 75,
  DUCK: 70, WICKET_STATS: 60
};

export function createAnimationController({ now = Date.now, forward = null, onChange = null } = {}) {
  let active = null;
  let queue = [];
  const priorityOf = item => ANIMATION_PRIORITIES[item?.type] || 20;
  const publish = () => onChange?.(active, queue.slice());

  function start(item, initialize) {
    active = { ...item, startTs: now() };
    initialize?.(active);
  }

  function trigger(item, { initialize } = {}) {
    if (!item?.type) return false;
    const priority = priorityOf(item);
    if (active && priority > priorityOf(active)) {
      start(item, initialize);
      queue = queue.filter(queued => priorityOf(queued) >= priority);
    } else if (!active) {
      start(item, initialize);
    } else {
      queue.push({ ...item });
    }
    forward?.(item);
    publish();
    return true;
  }

  function advance(at = now(), initialize) {
    if (!active) return null;
    if (at - active.startTs <= (active.duration || 2500)) return active;
    if (queue.length > 0) start(queue.shift(), initialize);
    else active = null;
    publish();
    return active;
  }

  function clear() {
    active = null;
    queue = [];
    publish();
  }

  function setActive(value) {
    active = value;
    publish();
  }

  function setQueue(value) {
    queue = Array.isArray(value) ? value.slice() : [];
    publish();
  }

  return { trigger, advance, clear, getActive: () => active, getQueue: () => queue.slice(), setActive, setQueue };
}
